// ServiceScreen.js - ফিক্সড ভার্সন
import React, {useState} from 'react';
import {
  View,
  Text,
  StyleSheet,
  ScrollView,
  TouchableOpacity,
  Dimensions,
} from 'react-native';
import Icon from 'react-native-vector-icons/MaterialIcons';

const {width} = Dimensions.get('window');

const ServiceScreen = () => {
  const [activeTab, setActiveTab] = useState('all');

  const services = [
    {
      id: 1,
      title: 'দৈনিক বোর্ড',
      icon: 'event-note',
      description: 'প্রত্যেকদিনের সকল আদালতের জামিন ও শুনানি তালিকা দেখুন',
      category: 'court',
    },
    {
      id: 2,
      title: 'জি.আর শাখা কার্যতালিকা',
      icon: 'gavel',
      description: 'ঢাকা জেলার জি.আর শাখার সকল মামলা অনুসন্ধান করুন',
      category: 'case',
    },
    {
      id: 3,
      title: 'আদালত কার্যতালিকা',
      icon: 'list-alt',
      description: 'সকল ঢাকা জেলা আদালতের কার্যতালিকা দেখুন',
      category: 'court',
    },
    {
      id: 4,
      title: 'বদলী মামলা',
      icon: 'swap-horiz',
      description: 'বদলী মামলা নম্বর ও সাল দিয়ে জানুন',
      category: 'case',
    },
    {
      id: 5,
      title: 'আমার ডায়েরী',
      icon: 'book',
      description: 'আপনার চেম্বারের সকল মামলা অনলাইনে ম্যানেজ করুন',
      category: 'diary',
    },
    {
      id: 6,
      title: 'নোটিফিকেশন সার্ভিস',
      icon: 'notifications',
      description: 'আগামীকাল আপনার ডায়েরীর মামলা সম্পর্কে জানুন',
      category: 'notification',
    },
    {
      id: 7,
      title: 'অটো এসএমএস সার্ভিস',
      icon: 'sms',
      description: 'ধার্য তারিখের ২৪ ঘন্টা পূর্বে বাদী-বিবাদীকে এসএমএস',
      category: 'notification',
    },
    {
      id: 8,
      title: 'অটো কেস মনিটর',
      icon: 'monitor',
      description: 'আপনার মামলার সকল আপডেট মনিটর করুন',
      category: 'case',
    },
  ];

  const tabs = [
    {id: 'all', label: 'সকল'},
    {id: 'court', label: 'আদালত'},
    {id: 'case', label: 'মামলা'},
    {id: 'diary', label: 'ডায়েরী'},
    {id: 'notification', label: 'নোটিফিকেশন'},
  ];

  const filteredServices = services.filter(
    service => activeTab === 'all' || service.category === activeTab,
  );

  return (
    <View style={styles.container}>
      {/* Header */}
      <View style={styles.header}>
        <Text style={styles.headerTitle}>আমাদের সেবাসমূহ</Text>
        <Text style={styles.headerSubtitle}>ঢাকা জেলা আদালতের সকল সেবা</Text>
      </View>
      <View style={styles.container_body}>
        {/* Powered By */}
        {/* <View style={styles.poweredByContainer}>
          <Text style={styles.poweredByText}>
            Powered By: Siddique Enterprise
          </Text>
        </View> */}

        {/* Tabs */}
        <ScrollView
          horizontal
          showsHorizontalScrollIndicator={false}
          style={styles.tabsContainer}
          contentContainerStyle={styles.tabsContent}
        >
          {tabs.map(tab => (
            <TouchableOpacity
              key={tab.id}
              style={[
                styles.tabButton,
                activeTab === tab.id && styles.tabButtonActive,
              ]}
              onPress={() => setActiveTab(tab.id)}
              activeOpacity={0.7}
            >
              <Text
                style={[
                  styles.tabText,
                  activeTab === tab.id && styles.tabTextActive,
                ]}
                numberOfLines={1}
              >
                {tab.label}
              </Text>
            </TouchableOpacity>
          ))}
        </ScrollView>

        {/* Services Grid */}
        <ScrollView
          style={styles.servicesGrid}
          showsVerticalScrollIndicator={false}
          contentContainerStyle={styles.servicesContent}
        >
          {filteredServices.map(service => (
            <TouchableOpacity
              key={service.id}
              style={styles.serviceCard}
              activeOpacity={0.8}
            >
              <View style={styles.serviceIconContainer}>
                <Icon name={service.icon} size={28} color="#307ecc" />
              </View>
              <View style={styles.serviceInfo}>
                <Text style={styles.serviceTitle} numberOfLines={1}>
                  {service.title}
                </Text>
                <Text style={styles.serviceDescription} numberOfLines={2}>
                  {service.description}
                </Text>
                <TouchableOpacity
                  style={styles.detailsButton}
                  activeOpacity={0.7}
                >
                  <Text style={styles.detailsButtonText}>বিস্তারিত</Text>
                </TouchableOpacity>
              </View>
            </TouchableOpacity>
          ))}
        </ScrollView>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f5f5f5',
  },
  container_body: {
    flex: 1,
    paddingHorizontal: 40,
  },
  header: {
    backgroundColor: '#307ecc',
    padding: 10,
    paddingTop: 10,
    paddingLeft: 40,
    // paddingBottom: 16,
  },
  headerTitle: {
    fontSize: 22,
    fontWeight: 'bold',
    color: '#fff',
  },
  headerSubtitle: {
    fontSize: 13,
    color: '#fff',
    opacity: 0.9,
    marginTop: 2,
  },
  poweredByContainer: {
    backgroundColor: '#fff',
    paddingVertical: 8,
    paddingHorizontal: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#eee',
  },
  poweredByText: {
    fontSize: 12,
    color: '#666',
    textAlign: 'center',
  },
  tabsContainer: {
    maxHeight: 50,
    marginVertical: 8,
  },
  tabsContent: {
    paddingHorizontal: 12,
    paddingVertical: 2,
  },
  tabButton: {
    paddingHorizontal: 20,
    paddingVertical: 8,
    borderRadius: 20,
    backgroundColor: '#fff',
    marginHorizontal: 4,
    minHeight: 36,
    justifyContent: 'center',
    shadowColor: '#000',
    shadowOffset: {width: 0, height: 2},
    shadowOpacity: 0.06,
    shadowRadius: 3,
    elevation: 2,
  },
  tabButtonActive: {
    backgroundColor: '#307ecc',
  },
  tabText: {
    fontSize: 13,
    color: '#666',
    fontWeight: '500',
    textAlign: 'center',
  },
  tabTextActive: {
    color: '#fff',
  },
  servicesGrid: {
    flex: 1,
  },
  servicesContent: {
    paddingHorizontal: 12,
    paddingBottom: 20,
    paddingTop: 2,
  },
  serviceCard: {
    flexDirection: 'row',
    backgroundColor: '#fff',
    borderRadius: 12,
    padding: 14,
    marginBottom: 10,
    shadowColor: '#000',
    shadowOffset: {width: 0, height: 2},
    shadowOpacity: 0.06,
    shadowRadius: 4,
    elevation: 2,
  },
  serviceIconContainer: {
    width: 56,
    height: 56,
    borderRadius: 28,
    backgroundColor: '#e8f0fe',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 14,
  },
  serviceInfo: {
    flex: 1,
    justifyContent: 'center',
  },
  serviceTitle: {
    fontSize: 15,
    fontWeight: 'bold',
    color: '#333',
    marginBottom: 2,
  },
  serviceDescription: {
    fontSize: 12,
    color: '#666',
    lineHeight: 17,
    marginBottom: 6,
  },
  detailsButton: {
    alignSelf: 'flex-start',
    backgroundColor: '#307ecc',
    paddingHorizontal: 14,
    paddingVertical: 4,
    borderRadius: 14,
    minHeight: 28,
    justifyContent: 'center',
  },
  detailsButtonText: {
    color: '#fff',
    fontSize: 12,
    fontWeight: '500',
  },
});

export default ServiceScreen;
